import * as React from 'react';

function CountdownCurveSvg() {
    return (
        <svg
            width="100%"
            height="35"
            viewBox="0 0 1303 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
        >
            <path
                d="M11 18.494C52.6473 10.7935 92.7988 9.30561 134.43 10.2539C168.351 11.0265 202.183 13.9076 236.015 14.374C264.547 14.7673 292.883 18.494 321.433 18.494C357.033 18.494 392.319 11.3085 427.823 12.3139C451.795 12.9928 475.932 17.9056 500.134 18.3796C526.119 18.8885 552.132 18.494 578.124 18.494C598.228 18.494 618.108 20.5541 638.201 20.5541C660.318 20.5541 681.978 15.5198 704.067 16.5485C786.214 20.3738 869.508 16.5569 951.801 14.1451C998.976 12.7625 1045.84 11.843 1093.04 12.3139C1125.11 12.6339 1157.3 16.1907 1189.38 17.3496C1212.8 18.1957 1238.24 15.1313 1261.47 18.6085C1267.84 19.562 1272.59 22.6141 1279.16 22.6141C1282.83 22.6141 1298.54 26.5831 1290.96 22.6141"
                stroke="#FFF3DA"
                strokeWidth="20"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default CountdownCurveSvg;
